import { render, staticRenderFns } from "./AddBallot.vue?vue&type=template&id=ccd5b036"
import script from "./AddBallot.vue?vue&type=script&lang=js"
export * from "./AddBallot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports